var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelebrity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dynamic",
    d: "M57.9371 6.98144C59.4217 4.07244 63.5783 4.07244 65.0629 6.98144L79.0109 34.3127C79.5921 35.4516 80.6828 36.244 81.9455 36.4448L112.249 41.2644C115.475 41.7773 116.759 45.7305 114.451 48.0413L92.7678 69.7525C91.8643 70.6572 91.4477 71.9393 91.6469 73.2023L96.4276 103.512C96.9365 106.738 93.5737 109.181 90.6628 107.701L63.3137 93.7877C62.1741 93.2079 60.8259 93.2079 59.6863 93.7877L32.3372 107.701C29.4263 109.181 26.0635 106.738 26.5724 103.512L31.3531 73.2023C31.5523 71.9393 31.1357 70.6572 30.2322 69.7525L8.54878 48.0413C6.24091 45.7305 7.52537 41.7773 10.7508 41.2644L41.0545 36.4448C42.3172 36.244 43.4079 35.4516 43.9891 34.3127L57.9371 6.98144Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "backGroundPath",
    d: "M72.5556 47.5556C72.5556 41.7352 67.8204 37 62 37C56.1796 37 51.4445 41.7352 51.4445 47.5556C51.4445 53.3751 56.1796 58.1103 62 58.1103C67.8204 58.1103 72.5556 53.3751 72.5556 47.5556Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "backGroundPath",
    d: "M62 60.317C51.5236 60.317 43 68.8406 43 79.317V83.5392C43 84.7053 43.9459 85.6503 45.1111 85.6503H78.8889C80.0541 85.6503 81 84.7053 81 83.5392V79.317C81 68.8588 72.5382 60.317 62 60.317Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrity);
export default __webpack_public_path__ + "static/media/celebrity.5afa267c825cca5d15335c5f629a250e.svg";
export { ForwardRef as ReactComponent };